import "./Heading_module.css";
const Heading_module_rslib_entry_ = {
    heading: "heading-WCiUiO",
    headingH1: "headingH1-lkHEpi",
    headingH2: "headingH2-PP5UEJ",
    headingH3: "headingH3-U68EZv",
    headingH4: "headingH4-QVDLSY",
    headingH5: "headingH5-iDIdGC",
    headingH6: "headingH6-aWD2EO",
    textAlignLeft: "textAlignLeft-BvL7Pr",
    textAlignCenter: "textAlignCenter-Avp6Ci",
    textAlignRight: "textAlignRight-DZQeoY",
    textAlignJustify: "textAlignJustify-ZlYA2n"
};
export { Heading_module_rslib_entry_ as default };

//# sourceMappingURL=Heading.module.js.map